<template>
  <v-list-item
    class="candidate-list-item"
    @click="onClickCandidate">
    <v-list-item-content>
      <v-list-item-title>
        <span>
          {{ renderSet.title }}
        </span>
        <v-tooltip
          v-if="isPromoted"
          top>
          <template
            v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              small
              color="success">
              mdi-check-circle
            </v-icon>
          </template>
          <span>In Disposition übernommen</span>
        </v-tooltip>
      </v-list-item-title>
      <v-list-item-subtitle>
        <span class="infospan text-left">{{renderSet.subTitle}}</span>
        <span class="infospan text-right secondary-information">{{renderSet.sortLabel}}</span>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import CandidateBL from '@/bl/candidateBl'
import { format } from 'date-fns'

export default {
  name: 'Candidate',
  props: {
    candidate: {
      type: Object,
      required: true
    }
  },
  computed: {
    name () {
      return CandidateBL.getName(this.candidate) || this.candidate.uuid
    },

    qualification () {
      return CandidateBL.getQualification(this.candidate)
    },

    team () {
      return CandidateBL.getTeamLabel(this.candidate) || undefined
    },

    renderSet () {
      const qualification = this.qualification || 'Keine Qualifikation gewählt'
      const team = this.team
      const subTitleComponents = [qualification]
      if (team) {
        subTitleComponents.push(team)
      }

      return {
        title: this.name,
        subTitle: subTitleComponents.join(' · '),
        sortLabel: this.created // todo
      }
    },

    created () {
      const date = CandidateBL.getDateCreated(this.candidate, true)

      return date
        ? format(date, 'd. MMM yyyy, H:mm') + ' Uhr'
        : void 0
    },

    isPromoted () {
      return CandidateBL.isPromoted(this.candidate)
    }
  },
  methods: {
    onClickCandidate () {
      this.$emit('clicked', this.candidate)
    }
  }
}
</script>

<style lang="scss">
  .candidate-list-item {
    height: 72px;
    border-bottom: 1px solid #f5f5f5;
  }
  .infospan {
    display: inline-block;
    width: 50%;
  }
  .secondary-information {
    opacity: 0.66
  }
</style>
